import { jsx as e } from "react/jsx-runtime";
import { QuantityPicker as r } from "./QuantityPicker.js";
import { FormField as a } from "../../FormField.js";
const i = ({ control: i2, name: n, label: o, required: m = false, preview: l = false, disabled: t, min: d, max: s, step: p, loading: c = false }) => e(a, { control: i2, name: n, label: o, required: m, preview: l, disabled: t, loading: c, children: ({ name: a2, onChange: i3, value: n2 }) => e(r, { name: a2, value: n2, onChange: (e2) => i3(e2), disabled: t, min: d, max: s, step: p }) });
export {
  i as InputQuantityField
};
//# sourceMappingURL=InputQuantityField.js.map
